module.exports = __webpack_public_path__ + "img/powr.51303f4c.svg";